<template>
  <div v-if="navSteps" class="ihu-nav-container">
    <IhuNavStep v-for="(step, index) in navSteps"
                :key="index"
                :data-testid="`ihu-widget-nav-step-${step.title}`"
                :state="getStepState(index)"
                :title="step.title"
                :subtitle="step.subtitle"
                @setStep="() => exportPosition(index)"></IhuNavStep>
  </div>
</template>

<script lang="js">
  import { NAVIGATOR_STATE } from '@/common/consts';
  import IhuNavStep from './ihu-nav-step';

  export default {
    name: 'ihu-nav-container',
    components: {
      IhuNavStep,
    },
    props: {
      currPosition: {
        type: Number,
        required: true,
      },
      navSteps: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
      };
    },
    methods: {
      exportPosition(idx) {
        this.$emit('setPosition', (idx + 1));
      },
      getStepState(idx) {
        const index = idx + 1;
        if (this.currPosition >= index) {
          return this.currPosition === index ? NAVIGATOR_STATE.ACTIVE : NAVIGATOR_STATE.DONE;
        }
        return NAVIGATOR_STATE.NONE;
      },
    },
  };
</script>

<style scoped lang="scss">
.ihu-nav-container {
  padding: 44px 24px;
}
</style>

